<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m22 10v-4c0-1.1-.9-2-2-2h-16c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46v2.54h-16v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46l-.01-2.54h16zm-10.93 7.46 2.93-1.88 2.93 1.88-.89-3.36 2.69-2.2-3.47-.21-1.26-3.23-1.27 3.22-3.47.21 2.69 2.2z"
    />
  </svg>
</template>
